import React, { useState } from "react";
import { Partner } from "../../api";
import { PartnerConfig } from "../../partner_config";
import { Spacer } from "../../spacer";
import { useMediaQuery } from "../../../hooks";
import {
  PortalSwitch,
  PortalSwitchValue,
} from "../../portal/components/portal_switch";
import { MembershipCardList } from "../../portal/components/membership_card_list";
import { TemplatePartnerPortalIndexV2 } from "./template_partner_portal_index_v2";
import { useMembershipPortalFeatureFlag } from "../../../core/splitio";
import { PortalMultiPassView } from "../components/portal_multi_pass_view";
import { useCheckPurchaseStatus } from "../../../data/api";
import { useMembershipSubscriptionQuery } from "../hooks/use_membership_subscription_query";
import { useAuth0 } from "@auth0/auth0-react";

interface PortalHomePageProps {
  partnerConfig: PartnerConfig;
  partner: Partner;
}

export function PortalHomePage({
  partner,
  partnerConfig,
}: PortalHomePageProps) {
  const { device } = useMediaQuery();
  const membershipPortalFlag = useMembershipPortalFeatureFlag(partner.id);
  const { user } = useAuth0();

  const { purchasedMembershipPortal, purchasedMultiPass } =
    useCheckPurchaseStatus({
      email: user!.email!,
      partnerId: partner.id,
    });

  const { subscriptions } = useMembershipSubscriptionQuery(partner.id);

  const [portalSwitchValue, setPortalSwitchValue] = useState<PortalSwitchValue>(
    purchasedMembershipPortal
      ? PortalSwitchValue.Memberships
      : PortalSwitchValue.MultiPasses
  );

  return (
    <TemplatePartnerPortalIndexV2
      partner={partner}
      partnerConfig={partnerConfig}
    >
      <div>
        <Spacer size={device === "mobile" ? 16 : 80} />
        <PortalSwitch
          value={portalSwitchValue}
          onChange={setPortalSwitchValue}
          partner={partner.name}
          showSwitch={
            purchasedMembershipPortal &&
            purchasedMultiPass &&
            membershipPortalFlag
          }
          subscriptionCount={subscriptions?.length}
        />
        <Spacer size={device === "mobile" ? 32 : 40} />
        {portalSwitchValue === PortalSwitchValue.Memberships ? (
          <MembershipCardList partnerId={partner.id} />
        ) : (
          <PortalMultiPassView partner={partner} />
        )}
      </div>
    </TemplatePartnerPortalIndexV2>
  );
}
